import { useEffect } from 'react'

export const ConsentContent = ({
  consentData,
  index,
  showReadMoreButton = true,
}: {
  consentData: string
  index: number
  showReadMoreButton?: boolean
}) => {
  useEffect(() => {
    const script = window?.document?.getElementById('myScript').innerHTML
    window.eval(script)
  })

  const readmore = showReadMoreButton
    ? `<button class="read-more" onClick="toggleReadMore(event, ${index} )">Read More</button>`
    : ''

  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: `<!DOCTYPE html>
                    <html>
                    <head>
                    <script id="myScript">
                    function toggleReadMore(event, index) {
                      const consentBody = document.querySelectorAll('.consent-body')[index];
                      const readMoreButton = event.target;
                      if (consentBody.style.webkitLineClamp === '') {
                        consentBody.style.webkitLineClamp = '2';
                        readMoreButton.textContent = 'Read More';
                      } else {
                        consentBody.style.webkitLineClamp = '';
                        readMoreButton.textContent = 'Read Less';
                      }
                    }
                    </script>
                      <link rel="stylesheet" href="https://use.typekit.net/tcd8cwi.css">
                      <style>
                        a:link {
                        text-decoration: none;
                        color: #2075F0;
                        font-weight: 700;
                        }
                        a:visited {
                          text-decoration: none;
                          color: #2075F0;
                          font-weight: 700;
                          }
                          .consent-body {
                            color: #596379;
                            font-family: 'Graphie-Regular';
                            font-size: 12px;
                            
                          }
                          .read-more {
                            color: #596379;
                            font-family: 'Graphie-Regular';
                            font-size: 12px;
                            font-weight: 600;
                          }
                      </style>
                    </head>
                    <body>
                        <div>
                          <div class="consent-body" style="display: -webkit-box;
                          -webkit-box-orient: vertical;  
                          overflow: hidden;
                          -webkit-line-clamp: 2;" >
                            ${consentData}
                          </div>
                        </div>
                        ${readmore}
                    </body>
                    </html>
  `,
        }}
      ></div>
    </>
  )
}
